﻿export const marketingPreferencesRebrand = () => {

    const init = component => {        
        const checkboxes = [...component.querySelectorAll("input[type='checkbox']")];

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', event => {
                event.target.value = event.target.checked;
            });
        });
    };

    return {
        init,
        selector: '.marketing-preference-rebrand'
    };
};